import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { business, footerGroups, images, routes } from '../data/site';
import { SiteLink } from './SiteLink';
export function Footer() {
  return <footer className="w-full border-t border-ink/10 bg-white" data-id="element-148" data-mp="32o4d0g3lai96">
      <div className="mx-auto max-w-container px-5 py-12 sm:px-8" data-id="element-149" data-mp="32lrkj907gphv">
        <div className="flex flex-col gap-6 border-b border-ink/10 pb-8 lg:flex-row lg:items-start lg:justify-between lg:gap-12" data-id="element-150" data-mp="36q9354utwwr2">
          <SiteLink to={routes.home} aria-label="Pegasus Spas home" className="shrink-0" data-id="element-151" data-mp="3ucxo5zf4x5bw">
            <img src={images.logo} alt="Pegasus Spas & Leisure Products, since 1977" className="h-[62px] w-auto" width={352} height={140} loading="lazy" data-id="element-152" data-mp="37xwcimca4j2" />
          </SiteLink>
          <p className="max-w-3xl text-[16px] leading-7 text-ink/80" data-id="element-153" data-mp="29y5fdwbbxcsw">{business.footerSeo}</p>
        </div>

        <div className="grid grid-cols-1 gap-8 py-8 sm:grid-cols-2 lg:grid-cols-6" data-id="element-154" data-mp="2ez1iw8rrqwxs">
          {footerGroups.map(group => <nav key={group.title} aria-label={group.title} data-id="element-155" data-mp="3lbmtfq7jj4eu">
              <h2 className="text-[15px] font-bold uppercase text-ink" data-id="element-156" data-mp="3gbimaqsivm1a">{group.title}</h2>
              <ul className="mt-3 space-y-1.5" data-id="element-157" data-mp="3v7zvbbd8ooko">
                {group.links.map(link => <li key={link.label} data-id="element-158" data-mp="3q8dj9595dedg">
                    <SiteLink to={link.href} className="inline-block py-1 text-[15.5px] leading-6 text-ink/80 transition-colors duration-150 ease-out hover:text-pegasus-blue" data-id="element-159" data-mp="3q7bxa5qlf7gy">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>

        <div className="grid grid-cols-1 gap-6 border-t border-ink/10 pt-8 sm:grid-cols-3" data-id="element-160" data-mp="cvtn246xb9bi">
          <div className="flex items-start gap-2.5" data-id="element-161" data-mp="qtrs2izcttec">
            <MapPinIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-162" data-mp="mspnrnqkyr5i" />
            <address className="text-[16px] not-italic leading-6 text-ink" data-id="element-163" data-mp="tvw5sbdtv5dc">
              {business.name}
              <br data-id="element-164" data-mp="ytef42vrbmlv" />
              {business.street}
              <br data-id="element-165" data-mp="yrv00flu7hlo" />
              {business.cityStateZip}
            </address>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-166" data-mp="13r7nn2kj8spb">
            <PhoneIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-167" data-mp="18l2eqr2gw9yf" />
            <p className="text-[16px] leading-6 text-ink" data-id="element-168" data-mp="1cmdywh2ko2z8">
              Voice or text
              <br data-id="element-169" data-mp="1hk5w9qlzkhat" />
              <a href={business.phoneHref} className="font-bold text-pegasus-blue underline decoration-pegasus-blue/40 underline-offset-4 transition-colors duration-150 ease-out hover:text-pegasus-magenta" data-id="element-170" data-mp="1hjnqo3dfoqq8">
                {business.phone}
              </a>
            </p>
          </div>
          <div className="flex items-start gap-2.5" data-id="element-171" data-mp="3od85lcgo84lz">
            <ClockIcon className="mt-1 h-5 w-5 shrink-0 text-pegasus-blue" aria-hidden="true" data-id="element-172" data-mp="3tb9lxpmppptr" />
            <div className="text-[16px] leading-6 text-ink" data-id="element-173" data-mp="2afdh79cf72n7">
              {business.hours.map(entry => <div key={entry.days} data-id="element-174" data-mp="25nc8fxegnu1x">
                  {entry.days} {entry.time}
                </div>)}
            </div>
          </div>
        </div>

        <p className="mt-8 text-[14.5px] text-ink/70" data-id="element-175" data-mp="1wnz05822pbis">
          © {new Date().getFullYear()} {business.name}. Brooklyn, Michigan.
        </p>
      </div>
    </footer>;
}